/**
 * @project: certiapp-nuxt
 * @file:    \store\signatures.js
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 22nd August 2022
 * Last Modified: Fri May 05 2023
 **/

export const state = () => ({})

export const mutations = {}

const construirFormDataFirma = (params) => {
  let data = new FormData()

  if ('modulo_ref' in params || 'submodulo_ref' in params) {
    throw new Error(
      'signatures: usa moduloRef/submoduloRef en lugar de modulo_ref/submodulo_ref.'
    )
  }

  if (!params.file && !params.base64) {
    throw new Error('signatures: se requiere file o base64 para guardar una firma.')
  }

  if (!params.modulo) {
    throw new Error('signatures: falta el campo obligatorio modulo.')
  }

  if (!params.moduloRef) {
    throw new Error('signatures: falta el campo obligatorio moduloRef.')
  }

  if (params.moduloRef === 'undefined') {
    throw new Error('signatures: moduloRef no puede ser la cadena "undefined".')
  }

  if (params.submodulo === 'undefined') {
    throw new Error('signatures: submodulo no puede ser la cadena "undefined".')
  }

  if (params.submoduloRef === 'undefined') {
    throw new Error('signatures: submoduloRef no puede ser la cadena "undefined".')
  }

  if (params.file) data.append('file', params.file)
  if (params.base64) data.append('base64', params.base64)

  data.append('modulo', params.modulo)
  data.append('moduloRef', params.moduloRef)
  if (params.submodulo) data.append('submodulo', params.submodulo)
  if (params.submoduloRef) data.append('submoduloRef', params.submoduloRef)

  if (params.user) data.append('user', params.user)
  if (params.representante) data.append('representante', params.representante)

  return data
}

export const actions = {
  //+-------------------------------------------------
  // latest()
  // Returns latest items for the user
  // -----
  // Created on Mon Aug 22 2022
  //+-------------------------------------------------
  async latest({ rootState }, userUUID) {
    rootState.loading = true
    // console.warn('endpoint firmas/latest not implemented')
    /* const xhr = await this.$axios.get(`firmas/` + userUUID)

    rootState.loading = false
    if (xhr) return xhr.data */
  },

  //+-------------------------------------------------
  // list()
  // Returns all items
  // -----
  // Created on Mon Sep 20 2021
  //+-------------------------------------------------
  async list({ rootState }, params) {
    rootState.loading = true

    const xhr = await this.$axios.get(`shares`)

    rootState.loading = false
    if (xhr) return xhr.data
  },

  //+-------------------------------------------------
  // create()
  // -----
  // Created on Mon Aug 22 2022
  //+-------------------------------------------------
  async create({ rootState }, params) {
    rootState.loading = true

    try {
      const data = construirFormDataFirma(params)

      const xhr = await this.$axios.post(`firmas`, data)

      if (xhr) return xhr.data
    } finally {
      rootState.loading = false
    }
  },

  //+-------------------------------------------------
  // update()
  // -----
  // Created on Wed Sep 22 2021
  //+-------------------------------------------------
  async update({ rootState }, params) {
    rootState.loading = true

    try {
      if (!params.identificadorFirma) {
        throw new Error('signatures: falta identificadorFirma para actualizar la firma.')
      }

      const data = construirFormDataFirma(params)

      const xhr = await this.$axios.post(`firmas/${params.identificadorFirma}/update-firma`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (xhr) return xhr.data
    } finally {
      rootState.loading = false
    }
  },

  //+-------------------------------------------------
  // delete()
  // -----
  // Created on Fri Jun 04 2021
  //+-------------------------------------------------
  // async delete({rootState}, item) {
  //   rootState.loading = true
  //   await this.$axios.delete(`shares/${item.uuid}`)
  //   rootState.loading = false
  // },
}
